import { UserDetailsService } from "./service/userdetails/user-details.service";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
/*
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
*/
import { registerLocaleData, DecimalPipe, CurrencyPipe } from "@angular/common";
import { environment } from "../environments/environment";
import { DatePipe } from "@angular/common";
import { AppRoutingModule } from "./app-routing.module";
import { AgmCoreModule } from "@agm/core";
import { AgmDirectionModule } from "agm-direction";
import { RightinfoService } from "./service/rightinfo.service";
import { AmplifyAngularModule, AmplifyService } from "aws-amplify-angular";
import { AwsService } from "./providers/appsyncservice/aws.service";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { Ng2OrderModule } from "ng2-order-pipe"; //importing the module
import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
import { AuthService } from "./guard/auth.service";
import { AuthGuard } from "./guard/auth.guard";
import { OtpService } from "./service/otpservice/otp.service";
import { HttpClientModule } from "@angular/common/http";
import { BnNgIdleService } from "bn-ng-idle"; // import bn-ng-idle service

import { AppComponent } from "./app.component";
import { HeaderComponent } from "./layout/header/header.component";
import { FooterComponent } from "./layout/footer/footer.component";
import { HomeComponent } from "./layout/home/home.component";
import { LeftnavComponent } from "./layout/leftnav/leftnav.component";
import { DashboardComponent } from "./components/dashboard/dashboard/dashboard.component";
import { AlertlogscreenComponent } from "./components/alertlogscreen/alertlogscreen.component";
import { FinishedscreenComponent } from "./components/finishedscreen/finishedscreen.component";
import { TriprequestscreenComponent } from "./components/triprequestscreen/triprequestscreen.component";
import { RemainingscreenComponent } from "./components/remainingscreen/remainingscreen.component";
import { RightinfoComponent } from "./layout/rightinfo/rightinfo/rightinfo.component";
import { TripdirectionComponent } from "./components/tripdirection/tripdirection.component";
import { DriverlistPipe } from "./pipes/driverlist.pipe";
import { DatePipePipe } from "./pipes/date-pipe.pipe";
import { DriverlistviewComponent } from "./components/driverlistview/driverlistview.component";
import { AdminmapComponent } from "./components/adminmap/adminmap.component";
import { AlertboxComponent } from "./components/alertbox/alertbox.component";
import { UploadscreenComponent } from "./components/uploadscreen/uploadscreen.component";
import { CompleteinfoComponent } from "./components/completeinfo/completeinfo.component";
import { RemaininfoComponent } from "./components/remaininfo/remaininfo.component";
//import { UserTripsComponent } from './components/Master/user-trips/user-trips.component';
import { NgxPaginationModule } from "ngx-pagination";
//import { TripMasterComponent } from '../app/components/Master/trip-master/trip-master.component';
//import { UserComponent } from './components/Master/user/user.component';
import { LoginComponent } from "./components/login/login.component";
import { DrivertripdetailsComponent } from "./components/drivertripdetails/attendance/drivertripdetails.component";
import { TripTypePipePipe } from "./pipes/trip-type-pipe.pipe";
import { AlertTypePipePipe } from "./pipes/alert-type-pipe.pipe";
import { UserTypePipePipe } from "./pipes/user-type-pipe.pipe";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { TripStatusPipePipe } from "./pipes/trip-status-pipe.pipe";
import { VehicleComponent } from "./components/drivertripdetails/vehicle/vehicle.component";
import { TripMstComponent } from "./components/Master/trip-mst/trip-mst.component";
import { ScUserTripComponent } from "./components/Master/sc-user-trip/sc-user-trip.component";
import { RncUsersComponent } from "./components/Master/rnc-users/rnc-users.component";
import { RncCarDataComponent } from "./components/ManageResource/rnc-cardata/rnc-cardata.component";
import { ProgressBarModule } from "angular-progress-bar";
import { GlobalSearchPipe } from "./pipes/global-search.pipe";
import { ExceldownloadComponent } from "./exceldownload/exceldownload.component";
import { WelnessComponent } from "./components/welness/welness.component";
import { CarRequestComponent } from "./components/car-request/car-request.component";
import { HouseMasterComponent } from "./components/ManageHouse/house-master/house-master.component";
import { AssignedHomeComponent } from "./components/ManageHouse/assigned-home/assigned-home.component";
import { HomeRequestComponent } from "./components/ManageHouse/home-request/home-request.component";
import { CarMasterComponent } from "./components/ManageCar/car-master/car-master.component";
import { AssignedCarComponent } from "./components/ManageCar/assigned-car/assigned-car.component";
import { CarMainRequestComponent } from "./components/ManageCar/car-main-request/car-main-request.component";
import { DriverMasterComponent } from "./components/ManageDriver/driver-master/driver-master.component";
import { DriverFeedbackComponent } from "./components/ManageDriver/driver-feedback/driver-feedback.component";
import { DriverConcernsComponent } from "./components/ManageDriver/driver-concerns/driver-concerns.component";
import { AssignedDriverComponent } from "./components/ManageDriver/assigned-driver/assigned-driver.component";
import { HouseRelocationComponent } from "./components/ManageHouse/house-relocation/house-relocation.component";
import { VendorDetailComponent } from "./components/ManageVendor/vendor-detail/vendor-detail.component";
import { AssignUserComponent } from "./components/ManageResource/assign-user/assign-user.component";
import { SearchFilterPipe } from "./pipes/search-filter.pipe";
import { CapSMSMailService } from "./service/capsmsmail/cap-smsmail.service";
import { DateutilService } from "./service/dateutil/dateutil.service";
import { DriverConfigComponent } from "./components/ManageDriver/driver-config/driver-config.component";
import { HouseUploadComponent } from "./components/ManageHouse/house-upload/house-upload.component";
import { CarUploadComponent } from "./components/ManageCar/car-upload/car-upload.component";
import { AwsAppServiceProvider } from "./providers/appsyncservice/ca.aws.notification.services";
import localeFr from "@angular/common/locales/en";
import localeFrExtra from "@angular/common/locales/extra/en";
import { AddVehicleComponent } from './components/vdms/add-vehicle/add-vehicle.component';
import { VehicleService } from './components/vdms/vdms_core/services/api/vehicle.service';
import { AwsS3BucketService } from './components/vdms/vdms_core/services/awsS3Bucket/aws-s3-bucket.service';
//import { VdmsTabsComponent } from "./components/vdms/vdms-tabs/vdms-tabs.component";
import { VdmsSharedModule } from "./components/vdms/vdms-tabs/vdms.tabs.modules";
import { VdmsTabsComponent } from "./components/vdms/vdms-tabs/vdms-tabs.component";
import { TabControlComponent } from "./components/vdms/vdms_shared/utils/tabs/tab-control.component";
import { TabPageComponent } from "./components/vdms/vdms_shared/utils/tabs/tab-page.component";
import { AssignedCarsComponent } from "./components/vdms/assigned-cars/assigned-cars.component";
import { SurrenderCarsComponent } from "./components/vdms/surrender-cars/surrender-cars.component";
import { UnassignedCarsComponent } from "./components/vdms/unassigned-cars/unassigned-cars.component";
import { VipCarsComponent } from "./components/vdms/vip-cars/vip-cars.component";
import { StringToDateAndRenewalPipe } from "./components/vdms/vdms_shared/pipes/renewal.status";
import { StringToDatePipe } from "./components/vdms/vdms_shared/pipes/StringToDatePipe";
import { statusColorText } from "./components/vdms/vdms_shared/pipes/status.pipes";
import { columnnFilterPipe } from "./components/vdms/vdms_shared/pipes/filter.pipes";
import { AddFuelCardDetailsComponent } from "./components/vdms/fuel-card-details/add-fuel-card-details/add-fuel-card-details.component";
import { FuelCardDetailsBlockedListComponent } from "./components/vdms/fuel-card-details/fuel-card-details-blocked-list/fuel-card-details-blocked-list.component";
import { FuelCardDetailsListComponent } from "./components/vdms/fuel-card-details/fuel-card-details-list/fuel-card-details-list.component";
import { FuelCardDetailsComponent } from "./components/vdms/fuel-card-details/fuel-card-details.component";
import { DateExpirePipe } from "./components/vdms/vdms_shared/pipes/date-expire.pipe";
import { FuelCardUnassignDetailsComponent } from './components/vdms/fuel-card-details/fuel-card-unassign-details/fuel-card-unassign-details.component';
import { ValueCheckingPipe } from "./components/vdms/vdms_shared/pipes/value-checking.pipe";
import { FuelCardCreditComponent } from './components/vdms/fuel-card-credit/fuel-card-credit.component';
import { AddFuelCardCreditComponent } from './components/vdms/fuel-card-credit/add-fuel-card-credit/add-fuel-card-credit.component';
import { CallbackComponent } from './components/callback/callback.component';
import { LogoutComponent } from "./components/logout/logout.component";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { AssignFuelCardComponent } from "./components/vdms/fuel-card-details/assign-fuel-card/assign-fuel-card.component";

registerLocaleData(localeFr, "en", localeFrExtra);
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LeftnavComponent,
    DashboardComponent,
    RightinfoComponent,
    TripdirectionComponent,
    AlertlogscreenComponent,
    FinishedscreenComponent,
    TriprequestscreenComponent,
    RemainingscreenComponent,
    DriverlistPipe,
    DatePipePipe,
    DriverlistviewComponent,
    AdminmapComponent,
    AlertboxComponent,
    UploadscreenComponent,
    CompleteinfoComponent,
    RemaininfoComponent,
    //UserTripsComponent,
    //TripMasterComponent,
    //UserComponent,
    LoginComponent,
    DrivertripdetailsComponent,
    TripTypePipePipe,
    AlertTypePipePipe,
    UserTypePipePipe,
    TripStatusPipePipe,
    VehicleComponent,
    TripMstComponent,
    ScUserTripComponent,
    RncUsersComponent,
    RncCarDataComponent,
    GlobalSearchPipe,
    ExceldownloadComponent,
    WelnessComponent,
    CarRequestComponent,
    HouseMasterComponent,
    AssignedHomeComponent,
    HomeRequestComponent,
    CarMasterComponent,
    AssignedCarComponent,
    CarMainRequestComponent,
    DriverMasterComponent,
    DriverFeedbackComponent,
    DriverConcernsComponent,
    AssignedDriverComponent,
    HouseRelocationComponent,
    VendorDetailComponent,
    AssignUserComponent,
    SearchFilterPipe,
    DriverConfigComponent,
    HouseUploadComponent,
    CarUploadComponent,
    AddVehicleComponent,
    FuelCardDetailsComponent,
    FuelCardDetailsListComponent,
    AddFuelCardDetailsComponent,
    FuelCardDetailsBlockedListComponent,
    DateExpirePipe,
    FuelCardUnassignDetailsComponent,
    ValueCheckingPipe,
    FuelCardCreditComponent,
    AddFuelCardCreditComponent,
    CallbackComponent,
    LogoutComponent,
    AssignFuelCardComponent,
    // VdmsTabsComponent,
    // TabControlComponent,
    // TabPageComponent,
    // AssignedCarsComponent,
    // SurrenderCarsComponent,
    // UnassignedCarsComponent,
    // VipCarsComponent,
    // StringToDateAndRenewalPipe,
    // StringToDatePipe,
    // statusColorText,
    // columnnFilterPipe

  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    /*
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    */
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyCOJu50WRJgFwfswb-rZqPviDOp_-pUEvk",
    }),
    AgmDirectionModule,
    AmplifyAngularModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,

    NgxPaginationModule,
    Ng2OrderModule,
    Ng2SearchPipeModule,
    ProgressBarModule,
    NgMultiSelectDropDownModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    VdmsSharedModule,
    //NgSelectModule,
  ],
  providers: [
    AmplifyService,
    /*
    AngularFirestoreModule,
    */
    RightinfoService,
    AwsService,
    OtpService,
    AuthService,
    AuthGuard,
    UserDetailsService,
    BnNgIdleService,
    CapSMSMailService,
    DateutilService,
    AwsAppServiceProvider,
    DatePipe,
    VehicleService,
    AwsS3BucketService,
    StringToDateAndRenewalPipe,
    DateExpirePipe,
    ValueCheckingPipe,
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
    }
  ],
  exports: [LeftnavComponent, HeaderComponent, NgxPaginationModule],

  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
